<template>
  <div class="sc-table">
    <div class="title">
      <img src="@/assets/圆圈.png" alt />
      <div>门店销售龙虎榜</div>
    </div>

    <div class="subtitle">
      <span class="statistics-date">销售时间</span>
      <!-- <el-date-picker v-model="date" type="date" placeholder="选择日期" :picker-options="pickerOptions"></el-date-picker> -->
      <el-date-picker
        v-model="startDate"
        type="date"
        placeholder="选择开始日期"
        :picker-options="pickerOptionsStart"
      ></el-date-picker>
      <span class="text-part">至</span>
      <el-date-picker
        v-model="endDate"
        type="date"
        placeholder="选择结束日期"
        :picker-options="pickerOptionsEnd"
      ></el-date-picker>
      <el-button type="primary" class="button" @click="onQuery">查询</el-button>

      <div class="sc-table-header-right">
        <div class="update-date" v-if="latestUpdateDate">
          最近更新时间：{{ util.toDateString(latestUpdateDate) }}
        </div>
        <div class="tips">
          <img src="@/assets/？.png" />
          <span
            >统计方式是单日销售数据，选择销售日期可查询一月内当日销售数据</span
          >
        </div>
      </div>
    </div>

    <el-table
      v-loading="loading"
      :data="retrieve"
      stripe
      style="width: 100%"
      header-cell-class-name="my-header-cell"
      header-row-class-name="my-header-row"
      row-class-name="my-row"
      cell-class-name="my-cell"
    >
      <el-table-column prop="ranking" label="排名" width="50">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="shop" label="门店" width="200"></el-table-column>
      <el-table-column prop="price" label="销售单价">
        <template slot-scope="scope">
          <span>{{ util.formatMoney(scope.row.price, 2, '￥') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" label="销售数量（单位）">
        <template slot-scope="scope">
          <span
            >{{ util.formatMoney(scope.row.quantity, 2, '') }}
            {{ scope.row.unit }}</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="销售金额（元）">
        <template slot-scope="scope">
          <span>{{ util.formatMoney(scope.row.amount, 2, '￥') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="profit" label="销售毛利额（元）">
        <template slot-scope="scope">
          <span>{{ util.formatMoney(scope.row.profit, 2, '￥') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="profitRate" label="销售毛利率">
        <template slot-scope="scope">
          <span
            >{{ util.formatMoney(scope.row.profitRate * 100, 2, '') }}%</span
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const oneDayMill = 24 * 60 * 60 * 1000

export default {
  name: 'SupplyChainProvinceSalesRanking',
  data() {
    return {
      loading: true,
      date: '',
      startDate: '',
      endDate: '',
      latestUpdateDate: undefined,
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      pickerOptionsStart: {
        disabledDate: this.disabledDateStart
      },
      pickerOptionsEnd: {
        disabledDate: this.disabledDateEnd
      },
      isInitDate: false
    }
  },
  computed: {
    retrieve() {
      const data = this.$store.state.sc.scSaleShop.ranking
      const time = this.$store.state.sc.scSaleShop.getSyncTime
      // 初始化起始日期
      if (time && !this.isInitDate) {
        if (!this.startDate) {
          this.startDate = new Date(time - oneDayMill)
        }
        if (!this.endDate) {
          this.endDate = new Date(time - oneDayMill)
        }
        this.isInitDate = true
        this.$emit('query', {
          startDate: this.startDate,
          endDate: this.endDate
        })
      }

      if (!this.latestUpdateDate) {
        this.latestUpdateDate = time && new Date(time)
      }
      this.loading = false
      // if (!data) {
      //   this.loading = false
      //   return {
      //     page: {
      //       totalCount: 0,
      //       numPerPage: 10,
      //       pageNum: 1
      //     },
      //     results: []
      //   }
      // }
      // if (data.results.length > 0) {
      //   this.loading = false
      //   if (!this.latestUpdateDate) {
      //     this.latestUpdateDate = time && new Date(time)
      //   }
      // }
      return data
    }
  },
  methods: {
    onCurrentChange(e) {
      this.$emit('change', e)
    },
    onQuery() {
      if (!this.startDate || !this.endDate) {
        this.$message.warning('请选择起始日期')
        return false
      }
      this.$emit('query', { startDate: this.startDate, endDate: this.endDate })
    },
    disabledDate(e) {
      return (
        e.getTime() > this.latestUpdateDate && this.latestUpdateDate.getTime()
      )
    },
    disabledDateStart(e) {
      if (!this.latestUpdateDate) {
        return true
      }

      if (e.getTime() > this.latestUpdateDate.getTime() - oneDayMill) {
        return true
      }
      // 原逻辑
      // if (
      //   e.getTime() > this.latestUpdateDate &&
      //   this.latestUpdateDate.getTime()
      // ) {
      //   return true
      // }
      // 开始日期不能超过结束日期 且不能跨月
      if (
        this.endDate &&
        (e.getTime() > this.endDate.getTime() ||
          e.getMonth() !== this.endDate.getMonth())
      ) {
        return true
      }
      return false
      // console.log(e.getTime()>this.endDate.getTime())
      // console.log('month',e.getMonth()!== this.endDate.getMonth())
      //  return e.getTime() > this.latestUpdateDate && this.latestUpdateDate.getTime()|| e.getTime()>this.endDate.getTime() || e.getMonth()!== this.endDate.getMonth();
    },
    disabledDateEnd(e) {
      if (!this.latestUpdateDate) {
        return true
      }

      if (e.getTime() > this.latestUpdateDate.getTime() - oneDayMill) {
        return true
      }
      // // 原逻辑
      // if (
      //   e.getTime() > this.latestUpdateDate &&
      //   this.latestUpdateDate.getTime()
      // ) {
      //   return true
      // }
      // 结束日期不能大于开始日期  且不能跨月
      if (
        this.startDate &&
        (e.getTime() < this.startDate.getTime() ||
          e.getMonth() !== this.startDate.getMonth())
      ) {
        return true
      }
      return false
      //  return e.getTime() > this.latestUpdateDate && this.latestUpdateDate.getTime() || e.getTime()<this.startDate.getTime() || e.getMonth()!== this.startDate.getMonth();
    }
  }
}
</script>

<style lang="less">
.sc-table {
  .my-header-cell {
    background: #94a49b;
    color: white;

    font-size: 12px;
    padding: 0;
    height: 40px;
  }
  .my-row {
    // height: 40px;
  }
  .my-cell {
    padding: 0;
    height: 40px;
    font-size: 12px;
  }
  .el-range-editor.el-input__inner {
    padding: 0 10px;
  }
  .el-button {
    padding: 9px 20px;
  }
  .el-button--primary {
    background-color: #1b994f;
    border-color: #1b994f;
  }
  .el-pagination {
    text-align: center;
    margin: 20px 0;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #1b994f;
    border-color: #1b994f;
  }
}
</style>

<style lang="less" scoped>
.sc-table {
  width: 1100px;

  .title {
    margin: 20px 0;
    img {
      display: inline-block;
      width: 12px;
      height: 12px;

      margin-right: 10px;
    }
    div {
      display: inline-block;
      width: 200px;
      height: 28px;
      font-size: 20px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 28px;
    }
  }

  .subtitle {
    padding: 10px 0;
    .statistics-date {
      width: 56px;
      height: 22px;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 22px;

      margin: 10px;
    }
    .button {
      margin-left: 10px;
    }
    .text-part {
      .statistics-date;
    }
  }
}
</style>
